import { Button, Dialog, DialogClose, TextField } from "@wilco/ui";
import { useState, type SubmitEvent } from "react";
import { t } from "../i18n.ts";
import { canUseCamera } from "../scan/camera.ts";
import { CameraView } from "../scan/CameraView.tsx";

/**
 * Скан на телефоне: камера, а под ней код вручную или сканером. Камера
 * включается только пока диалог открыт.
 */
export function ScanDialog({
  open,
  onOpenChange,
  onScan,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onScan: (code: string) => void;
}) {
  const [code, setCode] = useState("");
  const camera = canUseCamera();
  const finish = (value: string) => {
    onOpenChange(false);
    setCode("");
    onScan(value);
  };
  const submit = (e?: SubmitEvent) => {
    e?.preventDefault();
    const value = code.trim();
    if (value) finish(value);
  };
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("scan.dialog.title")}
      description={camera ? t("scan.dialog.camera") : t("scan.dialog.lead")}
      footer={
        <>
          <Button variant="primary" onClick={() => submit()}>
            {t("scan.submit")}
          </Button>
          <DialogClose asChild>
            <Button variant="ghost">{t("scan.cancel")}</Button>
          </DialogClose>
        </>
      }
    >
      {open && camera ? <CameraView onCode={finish} /> : null}
      <form onSubmit={submit}>
        {/* Фокус в поле сразу: ввод не ждёт анимацию («13»). На телефоне с
            камерой без автофокуса: клавиатура закрыла бы видео. */}
        <TextField
          label={t("scan.label")}
          variant="scan"
          placeholder={t("scan.placeholder")}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoFocus={!camera}
          autoComplete="off"
          enterKeyHint="search"
        />
      </form>
    </Dialog>
  );
}
